export default {
  path: '/cargos',
  component: () => import('@/components/pages/Roles/Roles.vue')
}
